import { ICardColorsState } from './types';
import { getShowColorsTooltipEditLocalStorage } from '../localstorage/actions/getShowColorsTooltipEditLocalStorage';

export const getInitialState = (
): ICardColorsState => ({
    isShowEditTooltip: getShowColorsTooltipEditLocalStorage(),
});
